import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ClientService', ClientService);

  ClientService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'UploadService',
    'WindowModalService',
    'ClientModalService',
    '$cacheFactory',
  ];

  function ClientService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    UploadService,
    WindowModalService,
    ClientModalService,
    $cacheFactory
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'clients';
    
    // Cache for clients list
    var clientsCache = $cacheFactory('clientsCache');

    var service = {
      getFilterCriteria: getFilterCriteria,
      getClients: getClients,
      getClient: getClient,
      searchClient: searchClient,
      saveClient: saveClient,
      deleteLogo: deleteLogo,
      openLogo: openLogo,
      updateLogo: updateLogo,
      deleteClient: deleteClient,
      changeClientStatus: changeClientStatus,
      updateClients: updateClients,
      openClientInfoModal: openClientInfoModal,
      clearClientsCache: clearClientsCache,
      hasClientsCache: hasClientsCache,
      openClientFastCreate: openClientFastCreate,
    };

    return service;

    ////////////////

    function hasClientsCache() {
      return clientsCache.get('all') !== undefined;
    }

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filter;
    }

    function getClients(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      // Return cached clients if requesting all clients (large per_page)
      if (filterCriteria.per_page >= 10000 && clientsCache.get('all')) {
        return Promise.resolve(clientsCache.get('all'));
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          if (!response || !response.data) {
            return {
              items: [],
            };
          }
          
          response = response.data;

          var result;
          if (response && response.meta) {
            result = {
              items: utils.cleanItemsCache(response.data, 'logo'),
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            result = {
              items: response || [],
            };
          }

          // Cache the result if requesting all clients (large per_page)
          if (filterCriteria.per_page >= 10000) {
            clientsCache.put('all', result);
          }

          return result;
        },
        {}
      );
    }

    function clearClientsCache() {
      clientsCache.removeAll();
    }

    function getClient(id, params) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          response.data.logoUrl = utils.cleanItemCache(response.data, 'logo');
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function searchClient(value) {
      var params = {
        company_id: SessionService.getSelectedAccountCompany().id,
        get: 'search',
        by_name: value,
      };

      return RestResource.request(
        'get',
        apiUrl,
        params,
        function (response) {
          return response.data.map(function (item) {
            return item;
          });
        },
        function () {
          return false;
        }
      );
    }

    function saveClient(item, cropedImage) {
      var itemAddedMsg = $translate('NEW_ADDED_CLIENT');
      var itemModifiedMsg = $translate('MODIFIED_CLIENT');

      var method = item.id ? 'PUT' : 'POST';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      item.company_id = SessionService.getSelectedAccountCompany().id;

      return UploadService.uploadFile(
        method,
        url,
        'client',
        item,
        cropedImage,
        function () {},
        function (response) {
          var msg = item.id ? itemModifiedMsg : itemAddedMsg;
          utils._successMsg(msg);
          
          // Clear cache so next request gets fresh data
          clearClientsCache();

          return response;
        },
        function () {}
      );
    }

    function deleteLogo(item) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'put',
        url,
        item,
        function (response) {
          utils._successMsg('PHOTO_DELETED');

          if (successCallback) {
            successCallback(response);
          }
        },
        function () {
          utils._errorMsg('ERROR_UPLOADING');
        }
      );
    }

    function openLogo(item, saveLogoCallBack) {
      utils.openLogo(item, saveLogoCallBack, 220, 220);
    }

    // Update logo after crop
    function updateLogo(item, cropedImage) {
      var url = apiUrl + '/' + item.id + '?lang=' + config.DEFAULT_CONTENT_LANGUAGE;

      utils.updateLogo(url, 'client', item, cropedImage);
    }

    function deleteClient(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_CLIENT',
            itemName: item.name,
            reason: 'DELETE_ITEM_REASON',
            confirmButtonLabel: 'DELETE_CLIENT',
            successMsg: 'DELETED_CLIENT',
          };
          
          // Clear cache so next request gets fresh data
          clearClientsCache();

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeClientStatus(item) {
      let url = apiUrl + '/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function updateClients(action, items, successCallback) {
      utils.updateItems(apiUrl, action, items, successCallback);
    }

    function openClientInfoModal(item) {
      var templateUrl = './app/ajs/clients/modals/client-info-modal.html';

      var additionalParams = {
        dateDisplay: config.DATE_DISPLAY,
      };

      var modalParams = {
        title: 'CLIENT_DETAILS',
        item: item,
        additionalParams: additionalParams,
      };

      var confirmCallback = function () {
        //return getItemsCallback(selectedItem);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openClientFastCreate(item, successCallback) {
      ClientModalService.openClientFastCreateModal(item, successCallback);
    }
  }
})();
